import React, { FC, useMemo } from 'react';
import Collapse from 'epn-ui/umd/dist/components/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import styles from '@pages/offers/Filters/index.module.scss';
import { IGetTrafficSourcesCategoriesFormatted, IGetTrafficSourcesDataFormatted } from '@api/types';
import TrafficSourceOption from '@pages/offers/Filters/TrafficSourceFilter/TrafficSourceOption';

interface ITrafficSourceFilterProps {
    categoryTraffic: IGetTrafficSourcesCategoriesFormatted[];
    trafficSourcesData: IGetTrafficSourcesDataFormatted[];
    checkedTrafficSourceIds: string[];
    onChange: (sourceId: string) => void;
}

const TrafficSourceFilter: FC<ITrafficSourceFilterProps> = ({
    categoryTraffic,
    trafficSourcesData,
    checkedTrafficSourceIds,
    onChange,
}) => {
    const trafficOptionsByCategories = useMemo(
        () =>
            categoryTraffic?.map(category => ({
                ...category,
                options: trafficSourcesData
                    ?.filter(trafficSource => trafficSource.categoryId === category.priority)
                    .map(option => ({
                        ...option,
                        isChecked: checkedTrafficSourceIds.includes(option.id),
                    })),
            })) || [],
        [trafficSourcesData, checkedTrafficSourceIds, categoryTraffic],
    );

    const trafficSourcesList = useMemo(() => {
        return trafficOptionsByCategories?.map((source, index) => ({
            title: source.name,
            key: index,
            body: (
                <div className="flex flex-row flex-wrap md:flex-col gap-[8px]" key={source.name}>
                    {source?.options?.map(option => (
                        <TrafficSourceOption
                            key={option.id}
                            sourceOption={option}
                            onChange={onChange}
                        />
                    ))}
                </div>
            ),
        }));
    }, [trafficOptionsByCategories, onChange]);

    return (
        <div className={styles.collapse}>
            <Collapse
                items={trafficSourcesList}
                ghost
                expandIcon={({ isActive }) => {
                    if (isActive) {
                        return <FontAwesomeIcon icon={faChevronUp} style={{ color: '#64748B' }} />;
                    }
                    return <FontAwesomeIcon icon={faChevronDown} style={{ color: '#A4B3C8' }} />;
                }}
                style={{ border: 0 }}
                expandFirstItem
                defaultActiveKey={['0', '1', '2', '3', '4']}
            />
        </div>
    );
};

export default TrafficSourceFilter;
